import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

export const AboutPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const AboutSectionPassionContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  max-width: 1200px;
  margin: 20px auto;
  margin-top: 60px;
  margin-bottom: 60px;

  @media (max-width: 1350px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const AboutSectionPassionImage = styled.img`
  width: 60%;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
  object-fit: cover;

  @media (max-width: 1350px) {
    margin-right: 10%;
    margin-left: 10%;
    width: 80%;
  }
`;

export const AboutSectionPassionLine = styled.hr`
  margin-top: 40px;
  opacity: 0.2;
  width: 100%;
  background-color: lightgrey;
  height: 1px;
  border: none;
`;

export const AboutSectionPassionTextContainer = styled.div`
  margin-left: 20px;

  @media (max-width: 1350px) {
    margin-right: 10%;
    margin-left: 10%;
  }
`;

export const AboutSectionPassionIntroTitle = styled.h3`
  color: #3393f0;
  letter-spacing: 2px;
  font-size: 14px;
`;

export const AboutSectionPassionTitle = styled.h1`
  color: #17224d;
  margin-top: 20px;
`;

export const AboutSectionPassionText = styled.p`
  color: #17224d;
  margin-top: 20px;
`;

export const AboutSectionQuoteContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  max-width: 1200px;
  width: 100%;
  position: absolute;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  padding: 0 20px;

  @media (max-width: 1080px) {
    flex-direction: column;
    top: 50%;
  }

  @media (max-width: 500px) {
    top: 60%;
    margin-top: 10px;
  }
`;

export const AboutSectionQuoteTextContainerQuoteTitle = styled.h3`
  font-size: 40px;
  color: #17224d;

  @media (max-width: 500px) {
    top: -10%;
    position: absolute;
    margin-left: 10%;
    margin-right: 10%;
    font-size: 20px;
  }
`;

export const AboutSectionQuote = styled.div`
  position: relative;
  width: 100%;
  height: 60vh;

  @media (max-width: 1000px) {
    height: 80vh;
  }
`;

export const AboutSectionQuoteImage = styled.img`
  width: 100%;
  height: 60vh;
  object-fit: cover;
  object-position: center;

  @media (max-width: 1000px) {
    height: 80vh;
  }
`;

export const AboutSectionQuoteTextContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
  padding: 20px;
  border-radius: 10px;
  min-height: 100%;

  @media (max-width: 1080px) {
    width: 100%;
    min-height: auto;
  }

  @media (min-width: 901px) {
    margin-top: 80px;
  }

  @media (max-width: 500px) {
    margin-top: 30px;
  }
`;

export const AboutSectionQuoteTextContainerQuote = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
  padding: 20px;
  border-radius: 10px;
  min-height: 100%;

  @media (max-width: 1080px) {
    width: 100%;
    min-height: auto;
  }
`;

export const AboutSectionQuoteGradientOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    rgba(255, 255, 255, 0.5),
    rgba(255, 255, 255, 0.5)
  );
  z-index: 1;
`;

export const AboutSectionQuoteTextIntroTitle = styled.h3`
  letter-spacing: 2px;
  font-weight: lighter;
  color: #3393f0;
  font-size: 14px;
`;

export const AboutSectionQuoteTextTitle = styled.h1`
  margin-top: 20px;
`;

export const AboutSectionQuoteText = styled.p`
  margin-top: 20px;
  line-height: 1.8;
  text-align: left;
  color: #17224d;
  font-size: 14px;
`;

export const AboutSectionThird = styled.div`
  width: 100%;
`;

export const AboutSectionThirdContainer = styled.div`
  background-color: #17224d;
  width: 100%;
  text-align: center;
  padding-top: 100px;
  height: 40vh;

  @media (max-width: 405px) {
    padding-top: 25%;
  }
`;

export const AboutSectionThirdTitle = styled.h1`
  font-size: 40px;
  letter-spacing: 2px;
  color: white;

  @media (max-width: 700px) {
    font-size: 25px;
  }
`;

export const AboutSectionThirdIntroTitle = styled.h3`
  font-size: 20px;
  letter-spacing: 2px;
  color: white;
  margin-bottom: 20px;

  @media (max-width: 700px) {
    font-size: 15px;
  }
`;

export const AboutSectionThirdCards = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  gap: 20px;
  max-width: 1200px;
  margin: 20px auto;
  position: relative;
  top: -130px;
  z-index: 3;

  @media (max-width: 1350px) {
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
`;

export const AboutSectionThirdCardsCard = styled.div`
  width: 33%;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 36px;
  background: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
  min-height: 380px;

  opacity: 1;
  visibility: visible;
  transition: opacity 1.5s ease, transform 1.5s ease, visibility 0s 1.5s;

  &.is-visible {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
    transition: opacity 1.5s ease, transform 1.5s ease, visibility 0s;
  }

  @media (max-width: 1350px) {
    width: 80%;
    min-height: 380px;
  }
`;

export const AboutSectionThirdCardsCardIcon = styled(FontAwesomeIcon)`
  color: #3393f0;
  padding: 34px;
`;

export const AboutSectionThirdCardsCardTitle = styled.h2`
  margin-bottom: 20px;
  color: ${({ theme }) => theme.colors.darkblue};
`;

export const AboutSectionThirdCardsCardText = styled.p`
  text-align: center;
  height: 100%;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.darkblue};
`;

export const AboutSectionThirdCardsCardReadMoreButton = styled.div`
  border: 1px solid #3393f0;
  width: 120px;
  padding: 5px;
  border-radius: 12px;
  display: inline-block;
  color: #3393f0;
  text-align: center;
  margin-top: 30px;
  cursor: pointer;
`;

export const AboutSectionFourthContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  max-width: 1200px;
  margin: 20px auto;
  margin-top: -60px;
  margin-bottom: 60px;

  @media (max-width: 1350px) {
    flex-direction: column;
    align-items: center;
  }
`;
